// extracted by mini-css-extract-plugin
export default {"container":"style_container__xt8Hv","page":"style_page__Yv1EZ","error":"style_error__3VyiM"};